import { render } from "./IndexHeader.vue?vue&type=template&id=597341aa&scoped=true"
import script from "./IndexHeader.vue?vue&type=script&lang=js"
export * from "./IndexHeader.vue?vue&type=script&lang=js"

import "./IndexHeader.vue?vue&type=style&index=0&id=597341aa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597341aa"]])

export default __exports__